import { keyMirror } from '../../global/utils';

export {default as excludes } from './excludes';
export default keyMirror([
  'CHANGE_FILTER',
  'CHANGE_ORDER',
  'FETCH_FILTERED_HISTORY',
  'PROMISE_SAVE_PREFERENCES',
  'PROMISE_FETCH_PREFERENCES',

  'FETCH_COMMENTS',
  'PROMISE_SAVE_NEW_COMMENT',
  'PROMISE_SAVE_COMMENT',
  'PROMISE_DELETE_COMMENT',
  'TOGGLE_NEW_COMMENT_EDIT',
  'TOGGLE_COMMENT_EDIT',
  'SET_ERROR_MESSAGE',
  'ON_NEW_FIELD_CHANGE',
  'ON_FIELD_CHANGE',
  'GET_ALL_ATTACHMENTS',
  'PROMISE_UPLOAD_ATTACHMENT',
  'FETCH_ATTACHMENTS',
  'ON_SORT',
  'SORT_ATTACHMENTS_TABLE',
  'ON_PANEL_CHANGE',
  'TOGGLE_UPLOAD_MODAL_RDC',

  'FETCH_ADVANCED_COMMENTS',
  'PROMISE_SAVE_NEW_ADVANCED_COMMENT',
  'PROMISE_SAVE_ADVANCED_COMMENT',
  'PROMISE_DELETE_ADVANCED_COMMENT',
  'TOGGLE_NEW_ADVANCED_COMMENT_EDIT',
  'TOGGLE_ADVANCED_COMMENT_EDIT',
  'ON_NEW_ADVANCED_FIELD_CHANGE',
  'ON_FIELD_ADVANCED_CHANGE',
  'TOGGLE_ADVANCED_COMMENT_STATUS_PROMISE',
  'UPDATE_VAR_IN_STATE',
  'UPDATE_STATE',
  'ON_PAGE_CHANGE',

  'FETCH_DOCUMENT_META',
  'FETCH_DOCUMENT_META_EDIT',
  'FETCH_DOCUMENT_TAGS',

  'FETCH_DOCUMENT_DATA',
  'FETCH_SWITCHER_VISIBILITY',
  'ENABLE_SHARING_PROMISE',
  'DISABLE_SHARING_PROMISE',
  'ON_TAB_CLICK',

  'FETCH_MORE_DOCUMENT_DATA',
  'FETCH_WORKFLOW_DEFINITIONS',
  'START_WORKFLOW_PROMISE',

  'ON_SELECT_CHANGE',
  'TOGGLE_MODAL',
  'SHOW_FIRST_MODAL',
  'FETCH_ACTIVE_WORKFLOWS',
  'FETCH_COMPLETED_WORKFLOWS',

  'FETCH_DOC_VERSION',
  'TOGGLE_META_MODAL',
  'GET_FILE',
  'ON_CHANGE',
  'ON_SELECT_CHANGE',

  'FETCH_ASSOC_ITEMS',
  'PROMISE_EXECUTE_ACTION',
  'PROMISE_TAKE_OWNERSHIP',
  'PROMISE_CHANGE_TYPE',
  'PROMISE_LOCK_DOC',
  'PROMISE_UNLOCK_DOC',
  'FETCH_ASPECTS',
  'ADD_ASPECT',
  'PROMISE_APPLY_ASPECT',
  'REMOVE_ASPECT',
  'PROMISE_DELETE_DOC',
  'FETCH_AUTH_GOOGLE',
  'FETCH_RESUME_SHARING',
  'FETCH_EXPORTABLE',
  'PROMISE_UPLOAD_CONTENT',
  'PROMISE_DISCARD_CONTENT',
  'PROMISE_SAVE_CONTENT',
  'FETCH_UPDATE_DATA',

  'PROMISE_MOVE_FILE',
  'PROMISE_COPY_FILE',
  'PROMISE_REMOVE_RELATED_DOC',
  'PROMISE_UPDATE_RELATED_DOCS',
  'FETCH_RELATED_DOCS_AND_ATTACHMENTS',
  'DISABLE_PDF',
  'FETCH_PREFERENCES',
  'PROMISE_UPDATE_PREFERENCES',
  'IS_RESIZING',
  'PROMISE_EXECUTE_ACTION',
  'UPDATE_ACTIONS',
  'PROMISE_SAVE_DOC_META',

  // HISTORY
  'FETCH_HISTORY',

  'FETCH_RPA_ACTIONS',

  'FETCH_COMMENTS_NEW',
  'ON_ROWS_PER_PAGE_CHANGE',
  'COMMENTS_FILTER_CHANGE',
  'DOWNLOAD_ZIP',
]);

export const MAX_SEARCH_RESULTS = 9;
